"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

export function ProductGallery({
  images,
  title,
  activeImage,
  onSelectImage
}: {
  images: string[];
  title: string;
  activeImage?: string;
  onSelectImage?: (image: string) => void;
}) {
  const [internalActive, setInternalActive] = useState(images[0] || "");

  useEffect(() => {
    if (activeImage) {
      setInternalActive(activeImage);
    }
  }, [activeImage]);

  const active = activeImage || internalActive || images[0] || "";

  function handleClick(image: string) {
    setInternalActive(image);
    onSelectImage?.(image);
  }

  return (
    <div className="grid gap-2 lg:grid-cols-[64px_1fr]">
      <div className="order-2 flex gap-2 overflow-x-auto py-1 no-scrollbar lg:order-1 lg:flex-col lg:overflow-y-auto">
        {images.map((image, index) => (
          <button
            type="button"
            key={`${image}-${index}`}
            onClick={() => handleClick(image)}
            className={cn(
              "relative h-14 w-14 shrink-0 overflow-hidden rounded border bg-white transition",
              active === image
                ? "border-amazon-orange ring-2 ring-amazon-orange"
                : "border-slate-200 hover:border-slate-400 dark:border-white/10"
            )}
            aria-label={`View image ${index + 1}`}
          >
            <Image
              src={image}
              alt={`${title} thumbnail ${index + 1}`}
              fill
              sizes="56px"
              className="object-contain p-0.5"
            />
          </button>
        ))}
      </div>
      <div className="relative order-1 aspect-square overflow-hidden rounded bg-white lg:order-2 dark:bg-slate-900 border border-slate-100 dark:border-white/5">
        {active && (
          <Image
            src={active}
            alt={title}
            fill
            priority
            sizes="(max-width: 1024px) 100vw, 40vw"
            className="object-contain p-2"
          />
        )}
      </div>
    </div>
  );
}
